// @flow
import React from 'react';
import classnames from 'classnames';

import styles from './IconLabel.css';

type Name = {
  name: string,
  className: string,
};

type OwnProps = {
  'name': string | Array<Name>,
  'label'?: string,
  'labelVisible'?: boolean,
  'size'?: 'small' | 'default' | 'medium' | 'large' | string,
  'data-test'?: string,
  'className'?: string,
};

const IconLabel = ({
  name,
  label,
  labelVisible,
  size,
  'data-test': dataTest,
  className,
  ...props
}: OwnProps) => {
  const LinkHref = () => {
    if (Array.isArray(name)) {
      return (
        <React.Fragment>
          {name.map(icon => {
            return (
              <use xlinkHref={`#icon-${icon.name}`} className={icon.className} key={icon.name} />
            );
          })}
        </React.Fragment>
      );
    }

    return <use xlinkHref={`#icon-${name}`} />;
  };

  const svgSize =
    size && ['default', 'small', 'medium', 'large'].includes(size)
      ? `var(--icon-size-${size})`
      : size;
  const sizeStyles = size ? { height: svgSize, width: svgSize } : null;

  return (
    <div {...props} className={classnames(styles.component, className)} data-test={dataTest}>
      <svg style={sizeStyles} className={styles.svg} aria-hidden="true">
        <LinkHref />
      </svg>
      <span className={classnames({ [styles.label]: labelVisible })}>{label}</span>
    </div>
  );
};

export default IconLabel;
